(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      document.querySelectorAll('[data-belabelly-card-index]').forEach((item) => {
        const index = Number(item.dataset.belabellyCardIndex);
        if (Number.isNaN(index) || index >= 8) return;

        const image = item.querySelector('.belabelly-collection-card-gallery__img');
        if (!image || image.complete) return;

        image.loading = 'eager';
        if (index < 4) {
          image.setAttribute('fetchpriority', 'high');
        }
      });
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
